import { MobileNavLinksCMS } from './features/mobile-nav/components/MobileNavLinks';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import { createRoot } from 'react-dom/client';
import React, {useMemo} from 'react';
import { Provider } from 'react-redux';
import testStore from "@/store/testStore";

const rootEl = document.getElementById('MobileNavMenuRoot');

if (rootEl) {
  createRoot(rootEl).render(
      <ErrorBoundary silent>
        <Provider store={testStore}>
          {React.createElement(MobileNavLinksCMS, rootEl.dataset)}
        </Provider>
      </ErrorBoundary>
  );
}
